// src/utils/authToken.js
import { jwtDecode } from "jwt-decode";
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

/** Devuelve siempre un JWT vigente; si no existe o está a punto de caducar, lo renueva */
export async function getFreshToken() {
  let token = localStorage.getItem("token") || "";

  let needRefresh = true;
  if (token) {
    try {
      const { exp } = jwtDecode(token);          // «exp» está en segundos
      const now = Date.now() / 1000;             // en segundos también
      needRefresh = exp - now < 30;              // <30 s => pedimos otro
    } catch { needRefresh = true; }
  }

  if (!needRefresh) return token;                // OK, seguimos con el mismo

  try {
    const r = await axios.get(`${API}/obtener-token/`);
    token = r.data.access_token;
    localStorage.setItem("token", token);
    return token;
  } catch (e) {
    console.error("[authToken] no se pudo renovar el token", e);
    // devolvemos lo que hubiese; el interceptor manejará el 401 si falla
    return token;
  }
}
